// extracted by mini-css-extract-plugin
export default {"TextAriaField":"TextAriaStyle_TextAriaField__Z+3n9"};